module.exports = __webpack_public_path__ + "img/icon-books-shadow.b92373f7.png";